import React, { useCallback } from 'react';

import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { Box, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import { spacing } from 'ucl/themes/shared/primitives';

import PickupTimeSelector from 'components/pickup-time-selector';
import { primitive } from 'styles/constants/primitives';
import { isDelivery } from 'utils/service-mode';

import SectionHeading from '../section-heading';

import DeliveryDetails from './delivery-details';
import { PickupDetails } from './pickup-details';
import { PickupTimeHeadingContainer } from './styled';
import { ICartDetailsProps } from './types';

export const DetailsV2: React.FC<React.PropsWithChildren<ICartDetailsProps>> = ({
  readOnly = false,
  onTimeSelectorChange,
  onDeliveryStatusChange,
  timeSelectorValue,
  serverOrder,
  serviceMode,
  setAreDeliveryDetailsValid,
  isOrderTimedFire,
  isPickupTimeAvailable,
  phoneNumberInputRef,
  deliveryDetailsErrors,
}) => {
  const { formatMessage } = useIntl();

  const onChange = useCallback(
    (value: any) => onTimeSelectorChange && onTimeSelectorChange(value),
    [onTimeSelectorChange]
  );

  const isDeliveryOrder = isDelivery(serviceMode);
  timeSelectorValue = timeSelectorValue || 0;

  const sectionHeading = isDeliveryOrder ? 'deliveryDetails' : 'restaurantDetails';

  return (
    <>
      {isDeliveryOrder ? (
        <DeliveryDetails
          serverOrder={serverOrder}
          setAreDeliveryDetailsValid={setAreDeliveryDetailsValid}
          sectionHeading={sectionHeading}
          phoneNumberInputRef={phoneNumberInputRef}
          deliveryDetailsErrors={deliveryDetailsErrors}
        />
      ) : (
        <PickupDetails serviceMode={serviceMode} readOnly={readOnly} />
      )}
      {isOrderTimedFire && (
        <Box>
          <PickupTimeHeadingContainer>
            <SectionHeading>
              {isDeliveryOrder
                ? formatMessage({ id: 'deliveryTime' })
                : formatMessage({ id: 'pickUpTime' })}
            </SectionHeading>
            {timeSelectorValue === 0 && (
              <View style={styles.tooltip}>
                <MaterialIcons name="access-time-filled" size={12} color={primitive.bk.$bbqBrown} />
                <Text fontSize="xs" color={primitive.bk.$bbqBrown} marginLeft="$1">
                  {formatMessage({ id: 'pickupNowEta' })}
                </Text>
              </View>
            )}
          </PickupTimeHeadingContainer>
          <PickupTimeSelector
            onChange={onChange}
            onDeliveryStatusChange={onDeliveryStatusChange}
            isPickupTimeAvailable={isPickupTimeAvailable}
            showAsTime
            value={timeSelectorValue}
          />
        </Box>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  tooltip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    borderRadius: 5,
    paddingHorizontal: spacing.$2,
    marginLeft: spacing.$1,
    marginTop: spacing['$1.5'],
  },
});
